
import '../App.css';


import beforeImg from "../assets/transformation.jpeg";
import afterImg from "../assets/Transformation2.jpeg";
import CoreflowfitApp from "../components/CoreflowfitApp";
import { Link } from "react-router-dom";

import heroImage from '../assets/atilla.jpg';
import calisthenicsImg from '../assets/1.jpeg';
import breathImg from '../assets/breathe.jpeg';
import mobilityImg from '../assets/mobility1.jpeg';
import nutritionImg from '../assets/food.jpg';

// import CoreflowfitJournal from '../components/CoreflowfitJournal';
import FAQSection from '../components/FAQSection';
import Signup from '../components/Signup';
import Footer from '../components/Footer';
import VideoCarousel from '../components/VideoCarousel';
import Stripes from '../components/Stripes';
import Certifications from '../components/Certifications';
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Home = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        // Timeout ensures the DOM is fully rendered before scrolling
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [hash]);

  return (
    <>
      <div
        className="hero-section"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center', // better centering for mobile
          backgroundRepeat: 'no-repeat',
          height: '100vh',
          width: '100%',
          position: 'relative',
        }}
      >
        {/* Overlay */}
        <div className="overlay"></div>

        {/* Hero Content */}
        <div className="hero-content">
          <h3 className="transformation">
            Trusted By 1000+ transformations . 30+ years coaching
          </h3>

          <h3 className="transform">
            TRANSFORM <br />
            <span className="span">BODY, MIND</span><br />
            AND MOBILITY
          </h3>

          <p className="hero-paragraph">
            With over <strong>30 years</strong> in calisthenics and breathwork, I help real people in their 30s, 40s, 50s+ rebuild strength, confidence, and clarity.
            CoreFlowFit blends <strong>guided bodyweight workouts, mindful breathing,
              mobility training, and clean-eating guidance</strong> so you can step into your 2.0 self.
          </p>

          <a href="#coaching-section" className="button">
            See more <span className="button-arrow">&#8594;</span>
          </a>
        </div>

        {/* Social Bar */}
        <div className="social-bar">
          <hr />
          <span className="follow-text">Follow us:</span>

          {/* Facebook */}
          <a href="https://www.facebook.com/share/1ATp3vpbLJ/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook-f"></i>
          </a>

          {/* Instagram */}
          <a href="https://www.instagram.com/atillar8" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>

          {/* YouTube */}
          <a href="https://www.youtube.com/@atillarado5418" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-youtube"></i>
          </a>

          {/* TikTok */}
          <a href="https://www.tiktok.com/@atillarado" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-tiktok"></i>
          </a>

          {/* Threads */}
          <a href="https://www.threads.com/@atillar8" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-threads"></i>
          </a>

          <hr />
        </div>
      </div>
      <Stripes />

      {/* Process of Coaching */}
      <div className="coaching-process" id="coaching-section">


        {/* Coaching Section */}
        <div className="coaching-container">
          <h3 className="coach">WHAT I COACH</h3>
          <p className="pillars mb-5">
            Three simple pillars I use with every client. No gym,
            no machines, just solid fundamentals you can do
            anywhere.
          </p>
        </div>
      </div>

      {/* Process of Coaching */}
      <div className="coaching-process">

        <div className="image-wrapper">
          <Link to="/calisthenics" className="full-link">
            <img src={calisthenicsImg} alt="Calisthenics" />
            <div className="overlay"></div>
            <h3 className="work">CALISTHENICS</h3>
          </Link>
        </div>

        <div className="image-wrapper">
          <Link to="/breathwork" className="full-link">
            <img src={breathImg} alt="Breathwork" />
            <div className="overlay"></div>
            <h3 className="work">BREATHWORK</h3>
          </Link>
        </div>

        <div className="image-wrapper">
          <Link to="/mobility" className="full-link">
            <img src={mobilityImg} alt="Mobility" />
            <div className="overlay"></div>
            <h3 className="work">MOBILITY</h3>
          </Link>
        </div>

        <div className="image-wrapper">
          <Link to="/nutrition" className="full-link">
            <img src={nutritionImg} alt="Nutrition" />
            <div className="overlay"></div>
            <h3 className="work">NUTRITION</h3>
          </Link>
        </div>

      </div>




      {/* Fitness Journey */}
      <div className="container fitness" id="about-section">
        <h3 className="coach">
          LET ME TRANSFORM YOUR <br /> FITNESS JOURNEY
        </h3>
        <p className="pillars">
          I’ve always been passionate about movement and fitness, but for years I struggled with finding the right approach that was sustainable and balanced. I experimented with different training programs, diets, and approaches, but nothing seemed to align with how real life works.<br /><br />

          Over time, I learned that fitness isn’t about extreme diets or punishing workouts — it’s about consistency, smart training, and listening to your body. I discovered the power of functional strength, core stability, and mobility, combined with proper recovery and nutrition.<br /><br />

          That journey inspired me to create <span className="bold">Core Flow Fit</span> — a program and app that brings together the best exercises, nutrition guidance, and movement philosophy into a simple, achievable system. My mission is to help others build strength, energy, and confidence without the stress of extreme routines.<br /><br />

          <span className="bold">Core Flow Fit</span> is about real people, real progress, and real life. Whether you’re just starting out or looking to level up your training, this program meets you where you are and helps you move toward your goals safely and sustainably.
        </p>
      </div>

      <VideoCarousel />
      <Certifications />




      <div className="container fitness mt-5">
        <h3 className="coach text-center mb-5">MY TRANSFORMATION</h3>

        <div className="row align-items-center">

          {/* LEFT TABLE */}
          <div className="col-lg-5 col-12">
            <div className="table-box">

              <div className="table-head">
                <span></span>
                <span>Before</span>
                <span>After</span>
              </div>

              <div className="table-line"></div>

              <div className="table-row">
                <span>Weight</span>
                <span className="big">69 <small>kg</small></span>
                <span className="big">79 <small>kg</small></span>
              </div>

              <div className="table-row">
                <span>Body Fat</span>
                <span className="big">11 <small>%</small></span>
                <span className="big">14 <small>%</small></span>
              </div>

              <p className="note">
                Figures shown are illustrative examples. Individual results may vary.
              </p>

            </div>
          </div>

          {/* RIGHT IMAGES */}
          <div className="col-lg-7 col-12">
            <div className="images-wrapper">

              <div className="img-card">
                <img src={beforeImg} alt="Before" />
                <h4>BEFORE</h4>
              </div>

              <div className="img-card">
                <img src={afterImg} alt="After" />
                <h4>AFTER</h4>
              </div>

            </div>
          </div>

        </div>
      </div>


      <CoreflowfitApp />
      {/* <CoreflowfitJournal /> */}
      <FAQSection />
      <Signup />
      <Footer />

    </>
  );
};

export default Home;
